<template>
    <div class="team-department">
        <div class="d-flex align-items-center pt-2 pl-4 pr-3" @click="openView">
            <img class="mr-4" :src="iconSrc" :alt="title">
            <h2>{{ title }}</h2>
            <span class="icon-right-open-big pl-5 text-xl ml-auto"></span>
        </div>

        <transition name="slide">
            <article v-if="opened" class="team-department-view bg-body flex-column">
                <header class="d-flex align-items-center p-4 mt-5">
                    <img class="mr-4" :src="iconSrc" :alt="title">
                    <h2>{{ title }}</h2>
                    <span class="icon-cancel pl-5 ml-auto" style="margin-top: -10px;" @click="closeView"></span>
                </header>

                <overlayed-image height="24rem" :src="imgSrc"></overlayed-image>

                <div class="team-department-view-content">
                    <slot></slot>
                </div>

                <div v-if="email" class="px-4 pb-10">
                    <hr>
                    <p class="text-gray mb-0">
                        <span class="icon-mail"></span>
                        <a class="text-gray" :href="mailto">{{ email }}</a>
                    </p>
                </div>

                <span class="mb-8"></span>
            </article>
        </transition>
    </div>

</template>

<script>
    export default {
        props: {
            title: {type: String, required: true},
            iconSrc: {type: String, required: true},
            imgSrc: {type: String, required: true},
            email: {type: String, required: false},
        },

        data: function () {
            return {
                opened: false,
            }
        },

        computed: {
            mailto: function () {
                return 'mailto:' + this.email;
            },
        },

        mounted: function () {
            //
        },

        methods: {
            openView: function () {
                this.opened = true;
            },
            closeView: function () {
                this.opened = false;
            },
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    .team-department{
        border: .1rem solid $gray-lightest;

        > div{
            height: 4rem;
            color: $green-light;
            cursor: pointer;

            > img{
                height: 100%;
            }
        }

        .team-department-view{
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            z-index: $zindex-modal;
            overflow-y: scroll;

            &.slide-enter, &.slide-leave-to{
                transform: translate3d(100%, 0, 0);
            }
            &.slide-enter-active, &.slide-leave-active{
                transition: transform .5s ease;
            }
            &.slide-enter-to, &.slide-leave{
                transform: translate3d(0%, 0, 0);
            }

            > header{
                height: 5rem;
                color: $green-light;

                > img{
                    height: 120%;
                }

                > .icon-cancel{
                    cursor: pointer;
                }
            }

            > .team-department-view-content > ul {
                overflow-y: scroll;
                //max-height: 550px;
                margin-bottom: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/TeamDepartment.vue